module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "barpos-screen report-profit-page"
  }, [_c('div', {
    staticClass: "bar-pos-page report-profit-page__shell"
  }, [_c('section', {
    staticClass: "bills-drawer bills-drawer--full report-profit-page__panel",
    attrs: {
      "aria-label": _vm.locale.t('label_profit')
    }
  }, [_c('header', {
    staticClass: "receipts-head report-profit-page__head"
  }, [_c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v("💰 " + _vm._s(_vm.locale.t('label_profit')) + " " + _vm._s(_vm.formatMoney(_vm.totalProfit)) + " " + _vm._s(_vm.locale.t('label_currency')))]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("\n              " + _vm._s(_vm.locale.t('label_period')) + ": " + _vm._s(_vm.profitFromDate || '—') + " → " + _vm._s(_vm.profitToDate || '—') + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "section-top-xxs"
  }, [_c('b', {
    staticClass: "title"
  }, [_vm._v("\n                " + _vm._s(_vm.locale.t('label_total_profit')) + " [" + _vm._s(_vm.selectedProfitTab === 'orders' ? _vm.locale.t('label_profit_tab_orders') : _vm.locale.t('label_profit_tab_payments')) + "]: " + _vm._s(_vm.formatMoney(_vm.activeTotalProfit)) + " " + _vm._s(_vm.locale.t('label_currency')) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("\n                " + _vm._s(_vm.locale.t('label_items_count')) + ": " + _vm._s(_vm.activeProfitLines.length) + "\n              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "receipts-filters report-profit-page__filters"
  }, [_c('div', {
    staticClass: "search-main-wrap"
  }, [_c('div', {
    staticClass: "search-wrap report-profit-page__search-wrap"
  }, [_c('label', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.locale.t('label_from')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profitFromDate),
      expression: "profitFromDate"
    }],
    staticClass: "search",
    attrs: {
      "type": "date",
      "placeholder": _vm.locale.t('label_from')
    },
    domProps: {
      "value": (_vm.profitFromDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profitFromDate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "search-wrap report-profit-page__search-wrap"
  }, [_c('label', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.locale.t('label_to')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profitToDate),
      expression: "profitToDate"
    }],
    staticClass: "search",
    attrs: {
      "type": "date",
      "placeholder": _vm.locale.t('label_to')
    },
    domProps: {
      "value": (_vm.profitToDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profitToDate = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "chips section-top-xs"
  }, [_c('button', {
    staticClass: "chip",
    class: {
      active: _vm.selectedProfitTab === 'orders'
    },
    on: {
      "click": function($event) {
        _vm.selectedProfitTab = 'orders'
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.locale.t('label_profit_tab_orders')) + "\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "chip",
    class: {
      active: _vm.selectedProfitTab === 'payments'
    },
    on: {
      "click": function($event) {
        _vm.selectedProfitTab = 'payments'
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.locale.t('label_profit_tab_payments')) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex-container section-top"
  }, [_c('button', {
    staticClass: "new-button",
    on: {
      "click": function($event) {
        return _vm.loadProfits()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.locale.t('label_show')) + "\n            ")])])]), _vm._v(" "), (!_vm.profitsLoading) ? _c('section', {
    staticClass: "report-profit-page__charts"
  }, [_c('article', {
    staticClass: "report-profit-chart"
  }, [_c('header', {
    staticClass: "report-profit-chart__head"
  }, [_c('div', {
    staticClass: "report-profit-chart__title"
  }, [_vm._v(_vm._s(_vm.locale.t('label_profit_tab_orders')))]), _vm._v(" "), _c('div', {
    staticClass: "report-profit-chart__meta"
  }, [_vm._v("\n                " + _vm._s(_vm.locale.t('label_total_profit')) + ": "), _c('b', [_vm._v(_vm._s(_vm.formatMoney(_vm.chartTotalOrders)))]), _vm._v(" " + _vm._s(_vm.locale.t('label_currency')) + "\n              ")])]), _vm._v(" "), (_vm.ordersProfitChartData.length) ? _c('div', {
    staticClass: "report-profit-chart__body"
  }, _vm._l((_vm.ordersProfitChartData), function(p) {
    return _c('div', {
      key: 'ord-' + (p.id || p.name),
      staticClass: "report-profit-chart__row"
    }, [_c('div', {
      staticClass: "report-profit-chart__label",
      attrs: {
        "title": p.name
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.shortLabel(p.name, 22)) + "\n                  "), _c('span', {
      staticClass: "report-profit-chart__qty"
    }, [_vm._v("x" + _vm._s(p.quantity))])]), _vm._v(" "), _c('div', {
      staticClass: "report-profit-chart__bar-wrap"
    }, [_c('div', {
      staticClass: "report-profit-chart__bar report-profit-chart__bar--orders",
      style: ({
        width: _vm.chartWidth(p.profit, _vm.maxOrdersProfit)
      })
    })]), _vm._v(" "), _c('div', {
      staticClass: "report-profit-chart__value"
    }, [_vm._v("+" + _vm._s(_vm.formatMoney(p.profit)))])])
  }), 0) : _c('div', {
    staticClass: "report-profit-chart__empty"
  }, [_vm._v("😐 " + _vm._s(_vm.locale.t('label_no_profit_data_for_period')))])]), _vm._v(" "), _c('article', {
    staticClass: "report-profit-chart"
  }, [_c('header', {
    staticClass: "report-profit-chart__head"
  }, [_c('div', {
    staticClass: "report-profit-chart__title"
  }, [_vm._v(_vm._s(_vm.locale.t('label_profit_tab_payments')))]), _vm._v(" "), _c('div', {
    staticClass: "report-profit-chart__meta"
  }, [_vm._v("\n                " + _vm._s(_vm.locale.t('label_total_profit')) + ": "), _c('b', [_vm._v(_vm._s(_vm.formatMoney(_vm.chartTotalPayments)))]), _vm._v(" " + _vm._s(_vm.locale.t('label_currency')) + "\n              ")])]), _vm._v(" "), (_vm.paymentProfitChartData.length) ? _c('div', {
    staticClass: "report-profit-chart__body"
  }, _vm._l((_vm.paymentProfitChartData), function(p) {
    return _c('div', {
      key: 'pay-' + (p.id || p.name),
      staticClass: "report-profit-chart__row"
    }, [_c('div', {
      staticClass: "report-profit-chart__label",
      attrs: {
        "title": p.name
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.shortLabel(p.name, 22)) + "\n                  "), _c('span', {
      staticClass: "report-profit-chart__qty"
    }, [_vm._v("x" + _vm._s(p.quantity))])]), _vm._v(" "), _c('div', {
      staticClass: "report-profit-chart__bar-wrap"
    }, [_c('div', {
      staticClass: "report-profit-chart__bar report-profit-chart__bar--payments",
      style: ({
        width: _vm.chartWidth(p.profit, _vm.maxPaymentProfit)
      })
    })]), _vm._v(" "), _c('div', {
      staticClass: "report-profit-chart__value"
    }, [_vm._v("+" + _vm._s(_vm.formatMoney(p.profit)))])])
  }), 0) : _c('div', {
    staticClass: "report-profit-chart__empty"
  }, [_vm._v("😐 " + _vm._s(_vm.locale.t('label_no_profit_data_for_period')))])])]) : _vm._e(), _vm._v(" "), (!_vm.profitsLoading && _vm.activeProfitLines.length) ? _c('div', {
    staticClass: "receipts-body report-profit-page__body"
  }, _vm._l((_vm.activeProfitLines), function(p) {
    return _c('div', {
      key: p.id || p.name,
      staticClass: "receipt-line"
    }, [_c('div', {
      staticClass: "receipt-top"
    }, [_c('div', {
      staticClass: "left"
    }, [_c('div', {
      staticClass: "name",
      staticStyle: {
        "display": "flex",
        "align-items": "center",
        "gap": "10px"
      }
    }, [(p.image) ? _c('img', {
      staticClass: "item-thumb",
      staticStyle: {
        "width": "32px",
        "height": "32px",
        "border-radius": "8px"
      },
      attrs: {
        "src": p.image,
        "alt": ""
      }
    }) : _c('div', {
      staticClass: "cash-widget__icon",
      staticStyle: {
        "width": "32px",
        "height": "32px"
      }
    }, [_vm._v("🧾")]), _vm._v(" "), _c('span', {
      attrs: {
        "title": p.name
      }
    }, [_vm._v(_vm._s(p.name))]), _vm._v(" "), _c('span', {
      staticClass: "chip",
      staticStyle: {
        "height": "18px"
      }
    }, [_vm._v("\n              × " + _vm._s(p.quantity) + "\n            ")])])]), _vm._v(" "), _c('div', {
      staticClass: "right"
    }, [_c('div', {
      staticClass: "total",
      staticStyle: {
        "color": "green"
      }
    }, [_c('b', [_vm._v("+" + _vm._s(_vm.formatMoney(p.profit)))])])])])])
  }), 0) : _vm._e(), _vm._v(" "), (!_vm.profitsLoading && !_vm.activeProfitLines.length) ? _c('div', {
    staticClass: "receipts-empty report-profit-page__empty"
  }, [_c('div', [_vm._v("😐 " + _vm._s(_vm.locale.t('label_no_profit_data_for_period')))])]) : _vm._e(), _vm._v(" "), (_vm.profitsLoading) ? _c('div', {
    staticClass: "receipts-loading report-profit-page__loading"
  }, [_c('div', {
    staticClass: "spinner"
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.locale.t('label_loading')))])]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2c4498d8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Report/Profit.vue
// module id = 746
// module chunks = 0